import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import _ from "lodash";
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import DeleteIcon from "@material-ui/icons/Delete";
import { Dashboard as DashboardLayout } from "../../../../layouts";
import {
  getQuestionsByUser,
  getSubjectAreas,
  submitNewQuestion,
  markSubmittedFaqForDeletion,
  deleteQuestion,
  getFaqCmsSettings
} from "../../../../redux/actions/faqCmsActions";
import { generatePublicChatbotSnippet } from "../../../../redux/actions/connectionActions";
import { pushMessage, removeMessage } from "../../../../redux/actions/commonActions";
import { fetchSkill } from "../../../../redux/actions/skillActions";
import styles from "../../styles";
import QuestionForm from "../QuestionForm";
import { FAQ_CMS_REDUX_QUESTION_FORM_NAME } from "../../../../constants";
import { getCustomFieldsDefaultValues, extendFormDataWithSelectValues } from "../../faqCmsUtils";
import MaterialTableIcons from "../../materialTableIcons";
import { formatDate } from "../../../../common/utils";

const SUBMIT_NEW_QUESTION_FORM_ACTION = "SUBMIT_NEW_QUESTION_FORM_ACTION";
const MARK_QUESTION_FOR_DELETION_FORM_ACTION = "MARK_QUESTION_FOR_DELETION_FORM_ACTION";

// Todo change class name to be more precise?
class SubmitAndListFaqs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      questionFormIsDisabled: false,
      buttonForMarkingQuestionForDeletionIsVisible: false,
      lastFormActionButtonClicked: undefined
    };
    this.customFields = undefined;
    // Todo some common props in FaqCms
    this.faqsTableColumns = [
      { title: "Question", field: "question" },
      { title: "Subject Area", field: "subjectArea" },
      { title: "User", field: "user" },
      {
        title: "Date Submitted",
        field: "dateSubmitted",
        type: "date",
        defaultSort: "desc",
        render: rowData => formatDate(rowData["dateSubmitted"])
      },
      {
        title: "Status",
        field: "status"
      }
    ];
  }

  async componentDidMount() {
    const {
      skill,
      fetchSkill,
      generatePublicChatbotSnippet,
      publicChatbotProps,
      getQuestionsByUser,
      getSubjectAreas,
      getFaqCmsSettings
    } = this.props;

    if (!skill || _.isEmpty(skill)) {
      await fetchSkill();
    }

    if (!publicChatbotProps) {
      await generatePublicChatbotSnippet();
    }

    await Promise.all([getQuestionsByUser(), getSubjectAreas(), getFaqCmsSettings()]);
    const customFields = _.get(this.props.faqCmsSettings, "customFields", null);
    this.customFields = customFields && customFields.length ? customFields : null;

    this.setState({ isLoading: false });
  }

  resetFormAndReloadTableData = async () => {
    this.setState({ isLoading: true });
    await this.props.getQuestionsByUser();
    this.setState({ isLoading: false, questionFormIsDisabled: false });
  };

  stringSize(s) {
    return new Blob([s]).size;
  }

  handleQuestionFormSubmit = async (questionData, questionAction, successMsg) => {
    if (this.stringSize(questionData.htmlResponse) + this.stringSize(questionData.voiceResponse) > 22000) {
      this.props.pushMessage({
        type: "error",
        message: "Response too large, please reduce the length of HTML and/or voice response and try again"
      });
      return;
    }
    this.setState({ questionFormIsDisabled: true });
    const newQuestionData = extendFormDataWithSelectValues(questionData, this.customFields);
    await questionAction(newQuestionData);
    if (this.props.faqLibraryQuestionActionApiCallResponse === 200) {
      this.props.pushMessage({ type: "success", message: successMsg });
      await this.resetFormAndReloadTableData();
      return;
    }

    this.setState({ questionFormIsDisabled: false });
    this.props.pushMessage({ type: "error", message: "An error occurred while processing the question" });
  };

  handleFormActionButtonClick = action => {
    this.setState({ lastFormActionButtonClicked: action }, () =>
      this.props.dispatch(submit(FAQ_CMS_REDUX_QUESTION_FORM_NAME))
    );
  };

  showMarkQuestionForDeletionButton = () => {
    // Check if button is already visible
    if (this.state.buttonForMarkingQuestionForDeletionIsVisible) {
      return;
    }

    this.setState({ buttonForMarkingQuestionForDeletionIsVisible: true });
  };

  hideMarkQuestionForDeletionButton = () => {
    // Check if button is already hidden
    if (!this.state.buttonForMarkingQuestionForDeletionIsVisible) {
      return;
    }

    this.setState({ buttonForMarkingQuestionForDeletionIsVisible: false });
  };

  getSubmitQuestionButton = () => {
    const { classes } = this.props;
    const commonProps = { variant: "contained", disabled: this.state.questionFormIsDisabled }; // todo duplicate props in other class
    const buttons = [
      <Button
        key="submit-btn"
        color="primary"
        {...commonProps}
        onClick={() => this.handleFormActionButtonClick(SUBMIT_NEW_QUESTION_FORM_ACTION)}
      >
        Submit
      </Button>
    ];

    if (this.state.buttonForMarkingQuestionForDeletionIsVisible) {
      buttons.push(
        <Button
          key="delete-btn"
          className={classes.deleteQuestionButton}
          {...commonProps}
          onClick={() => this.handleFormActionButtonClick(MARK_QUESTION_FOR_DELETION_FORM_ACTION)}
        >
          Delete
        </Button>
      );

      return <div className={classes.reviewButtonsContainer}>{buttons}</div>;
    }

    return <div className={classes.submitNewQuestionButtonContainer}>{buttons}</div>;
  };

  getQuestionAction = () => {
    const { lastFormActionButtonClicked } = this.state;
    const { markSubmittedFaqForDeletion, submitNewQuestion } = this.props;

    switch (lastFormActionButtonClicked) {
      case MARK_QUESTION_FOR_DELETION_FORM_ACTION:
        return { questionAction: markSubmittedFaqForDeletion, successMsg: "Question successfully marked for deletion" };
      case SUBMIT_NEW_QUESTION_FORM_ACTION:
        return { questionAction: submitNewQuestion, successMsg: "Question submitted successfully" };
      default:
        return () => {};
    }
  };

  renderReviewQuestionForm = () => {
    const { classes, existingSubjectAreas, publicChatbotProps, faqCmsSettings } = this.props;
    const { questionFormIsDisabled } = this.state;
    const defaultCustomFields = getCustomFieldsDefaultValues(this.customFields);
    const publicChatbotId = publicChatbotProps ? publicChatbotProps.data.GUID : undefined;
    const { questionAction, successMsg } = this.getQuestionAction();
    const nonAdminsCanCreateSubjectAreas = _.get(faqCmsSettings, "nonAdminsCanCreateSubjectAreas", false);

    return (
      <Grid container justify="center">
        <Paper elevation={1} className={classes.questionFormContainer}>
          <QuestionForm
            searchOfFaqsEnabled={true}
            esIndexName={`${publicChatbotId}_user_upload`}
            customFields={this.customFields}
            formDisabled={questionFormIsDisabled}
            formData={{ ...defaultCustomFields }} // Mostly empty except possible custom fields since the form is used to create new questions
            buttons={this.getSubmitQuestionButton()}
            onSubmit={e => this.handleQuestionFormSubmit(e, questionAction, successMsg)}
            subjectAreas={existingSubjectAreas}
            showMarkQuestionForDeletionButton={this.showMarkQuestionForDeletionButton}
            hideMarkQuestionForDeletionButton={this.hideMarkQuestionForDeletionButton}
            nonAdminsCanCreateSubjectAreas={nonAdminsCanCreateSubjectAreas}
          />
        </Paper>
      </Grid>
    );
  };

  handleTableMarkFaqForDeletionClick = async (event, rowData) => {
    const { questionsByUser, markSubmittedFaqForDeletion, pushMessage } = this.props;

    pushMessage({
      type: "info",
      message: "Marking question for deletion. Please wait.",
      persist: false
    }); // Todo simply disable action instead of showing this msg?

    const rowIdx = rowData.tableData.id;
    const { docId } = questionsByUser[rowIdx];
    await markSubmittedFaqForDeletion({ docId });
    const { faqLibraryQuestionActionApiCallResponse } = this.props;

    if (faqLibraryQuestionActionApiCallResponse === 200) {
      pushMessage({
        type: "success",
        message: "Question marked for deletion and pushed into the review queue."
      });
      await this.resetFormAndReloadTableData();
      return;
    }

    pushMessage({ type: "error", message: "Failed to mark question for deletion." });
  };

  handleTableDeleteFaqClick = async (event, rowData) => {
    const { questionsByUser, deleteQuestion, pushMessage } = this.props;

    pushMessage({
      type: "info",
      message: "Deleting question. Please wait.",
      persist: false
    }); // Todo simply disable action instead of showing this msg?

    const rowIdx = rowData.tableData.id;
    const { docId } = questionsByUser[rowIdx];
    await deleteQuestion({ docId }, true);
    const { reviewApiCallResponse } = this.props;

    if (reviewApiCallResponse === 200) {
      pushMessage({
        type: "success",
        message: "Question successfully deleted."
      });
      await this.resetFormAndReloadTableData();
      return;
    }

    pushMessage({ type: "error", message: "Failed to delete question." });
  };

  getTrashCanTableAction = rowData => {
    let onClick = () => {};
    let tooltip = "";
    let disabled = false;
    let icon = () => <DeleteIcon />;

    if (rowData.canBeMarkedForDeletion) {
      onClick = this.handleTableMarkFaqForDeletionClick;
      tooltip = "Mark for Deletion";
    } else if (rowData.canBeDirectlyDeleted) {
      onClick = this.handleTableDeleteFaqClick;
      tooltip = "Delete";
      icon = () => <DeleteForeverIcon />;
    } else {
      disabled = true;
    }

    return {
      tooltip,
      onClick,
      disabled,
      icon
    };
  };

  renderTableWithQuestions = () => {
    return (
      <MaterialTable
        title="Previously Submitted Questions"
        icons={MaterialTableIcons}
        columns={this.faqsTableColumns}
        data={this.props.questionsByUser}
        options={{
          sorting: true
        }}
        actions={[this.getTrashCanTableAction]}
      />
    );
  };

  // Todo duplicate code in other class
  render() {
    return (
      <DashboardLayout title="FAQ CMS" isLoading={this.state.isLoading}>
        {this.renderReviewQuestionForm()}
        <div className={this.props.classes.tableWithQuestionsContainer}>{this.renderTableWithQuestions()}</div>
      </DashboardLayout>
    );
  }
}

function mapStateToProps(state) {
  const {
    existingSubjectAreas,
    questionsByUser,
    faqLibraryQuestionActionApiCallResponse,
    reviewApiCallResponse,
    settings
  } = state.faqCms;
  const { publicChatbotProps } = state.connections;
  const { skill } = state;

  return {
    skill,
    publicChatbotProps,
    existingSubjectAreas,
    questionsByUser,
    faqLibraryQuestionActionApiCallResponse,
    reviewApiCallResponse,
    faqCmsSettings: settings
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        pushMessage,
        removeMessage,
        fetchSkill,
        generatePublicChatbotSnippet,
        getQuestionsByUser,
        getSubjectAreas,
        submitNewQuestion,
        markSubmittedFaqForDeletion,
        deleteQuestion,
        getFaqCmsSettings
      },
      dispatch
    ),
    dispatch
  };
}

SubmitAndListFaqs = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitAndListFaqs);

export default withStyles(styles)(SubmitAndListFaqs);
